import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "ChildBusiness",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "DelItemByChildBusinessId",
  "DelItemList",
  "GetItemById",
  "GetItemByBusinessCodeAndChildBusinessCode",
  "GetItemByChildBusinessId",
  "FindByConditions",
  "GetItemByChildBusinessCode",
  "GetPageContentByConditions",
  "GetQRCode"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const ChildBusinessApi = ZJApi.defineNewApi("ChildBusinessApi", factory);

export default ChildBusinessApi;
